// import PropTypes from 'prop-types'
import Header from 'components/Header'
import Spacer from 'components/Spacer'
import Text from 'components/Text'

import { Main, Root, Section } from './JournalSections.style'

const JournalSections = ({ sections, selectedSlug }) => {
  return (
    <Root>
      <Header>Browse Sections</Header>
      <Spacer y={8} />
      <Main>
        {sections.map(({ title, slug }) => (
          <Section key={slug} href={`/journal/sections/${slug}`} $selected={selectedSlug === slug}>
            <Text font="proxima" tracking="wide" transform="uppercase">
              {title}
            </Text>
          </Section>
        ))}
      </Main>
    </Root>
  )
}

JournalSections.propTypes = {}

JournalSections.defaultProps = {}

export default JournalSections
